import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor() { }
  userPermission: null | string = null;
  
  checkPermission(){
    const permissionsJSON = sessionStorage.getItem('permissions')
    if(permissionsJSON !== null){
      const permissionsParsed = JSON.parse(permissionsJSON)
      permissionsParsed.filter((permission: any)=>{
        if(permission.app_name === 'CALENDAR-ADMIN'){
          this.userPermission = permission.permission_level;
        }
      })
    }
  }
}
